import { LitElement, html, css, t } from '@hh/global.js'

class HHBundleButtons extends LitElement {
  static properties = {
    currentStep: { type: Number },
    isCurrentStepFinished: { type: Boolean },
    isBundleFinished: { type: Boolean },
    isLoading: { type: Boolean },
    stepsCount: { type: Number },
  }

  constructor() {
    super();
  }

  _onPrevious() {
    this.dispatchEvent(new CustomEvent('onPrevStep', {
      bubbles: true,
      composed: true
    }));
  }

  _onNext() {
    this.dispatchEvent(new CustomEvent('onNextStep', {
      bubbles: true,
      composed: true
    }));
  }

  get nextLabel() {
    if (this.currentStep === this.stepsCount - 1 && this.isBundleFinished) return t('products.product.add_to_cart');
    return this.isCurrentStepFinished ? t('sections.main-bundle.next') : t('sections.main-bundle.make_selections');
  }

  render() {
    return html`
      <div class="bundle-buttons">
        ${this.currentStep > 0
          ? html`
            <hh-button
              class="w1"
              theme="secondary"
              full-width
              .onClick="${this._onPrevious}"
            >
              ${t('sections.main-bundle.previous')}
            </hh-button>
          `
          : ''
        }
        <hh-button
          class="w1"
          theme="primary"
          custom-color='var(--hh-color-brand-primary)'
          full-width
          .disabled="${this.isLoading || !this.isCurrentStepFinished}"
          .onClick="${this._onNext}"
        >
          ${this.nextLabel}
        </hh-button>
      </div>
    `
  }

  static styles = css`
    .bundle-buttons {
      display: flex;
    }
    :host([direction~='row']) .bundle-buttons {
      gap: var(--hh-spacing-xs);
    }
    .bundle-buttons hh-button {
      flex: 1;
      display: block;
    }
    .bundle-buttons hh-button {
      --hh-width: 100%;
      --hh-height: 4.5rem;
      --hh-max-height: 4.5rem;
      --hh-font: var(--hh-body-bold-sm-font);
      --hh-border-width: 0.5rem;
    }
    .bundle-buttons hh-button[theme="secondary"] {
      --hh-color: var(--hh-color-brand-secondary);
      --hh-border-color: var(--hh-color-brand-secondary);
    }

    @media (min-width: 1024px) {
      :host([direction~='row']) .bundle-buttons hh-button {
        --hh-width: 30rem;
      }
      :host([direction="column"]) .bundle-buttons {
        flex-direction: column-reverse;
        gap: var(--hh-spacing-xs);
      }
    }
  `
}

customElements.define('hh-bundle-buttons', HHBundleButtons);
if (!customElements.get('hh-bundle-buttons')) {
  customElements.define('hh-bundle-buttons', HHBundleButtons);
}
